var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mensagem",class:{
        lida: _vm.source.lido,
        critico: _vm.source.severidade === 'Crítico',
        alarme: _vm.source.severidade === 'Alarme',
        alerta: _vm.source.severidade === 'Alerta',
    },on:{"click":function($event){return _vm.$root.$emit('show-notification-details', _vm.source)}}},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"tipo"},[_vm._v(_vm._s(_vm.source.classe))]),_c('div',{staticClass:"data"},[_vm._v(_vm._s(_vm.source.dataHora))])]),_c('div',{staticClass:"body"},[_vm._v(_vm._s(_vm.source.mensagem))])])
}
var staticRenderFns = []

export { render, staticRenderFns }